module.exports = __webpack_public_path__ + "static/media/material-ui.cb2f65a2.svg";